import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

// Alleen op de echte front-end initialiseren. wp-admin, block-editor-iframes
// en customizer-previews krijgen geen Lenis — anders breekt native scrollen.
const isFrontEnd = typeof document !== 'undefined'
	&& document.body
	&& document.body.classList.contains( 'front-end' );

let lenis = null;

if ( isFrontEnd ) {
	lenis = new Lenis( {
		autoRaf: false,
	} );

	lenis.on( 'scroll', ScrollTrigger.update );

	gsap.ticker.add( ( time ) => {
		lenis.raf( time * 1000 );
	} );

	gsap.ticker.lagSmoothing( 0 );

	// Paginatransitie start (components/parts/page-loader): uitlopende scroll
	// stoppen. Bewust niet lenis.stop(): die zet overflow: clip op <html>, dan
	// verdwijnt de scrollbalk en verspringt de pagina.
	window.addEventListener( 'hellema:page-leave', () => lenis.reset() );
}

export { lenis };
